import { useNavigate as useTanstackNavigate } from '@tanstack/react-router';
export function useNavigate(options) {
    return useTanstackNavigate(options);
}
